export const skadesaker = {
    columns: [
        "Dato",
        "Saksnummer",
        "Kundenummer",
        "Kundenavn",
        "Milepæl",
        "Følger saken",
    ],
    rows: [
        [
            "24.02.2025",
            "20-1234567",
            "010203 99887",
            "Ola Nordmann",
            "Opprettet",
            "Siri Saksbehandler",
        ],
        [
            "13.04.2019",
            "20-8382811",
            "010203 99887",
            "Kari Nordkvinne",
            "Opprettet",
            "Siri Saksbehandler",
        ],
        [
            "31.07.2017",
            "20-1111",
            "010203 99887",
            "Kari Nordkvinne",
            "Opprettet",
            "Per Persen",
        ],
    ],
};

export const faktura = {
    columns: [
        "Forfallsdato",
        "Type",
        "Beløp",
        "Status",
        "Produkt",
        "Kontonummer",
        "KID",
        "Betalingstype",
    ],
    rows: [
        [
            new Date(2025, 10, 15),
            "Skade",
            612.32,
            "Faktura",
            ["Bilforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 9, 15),
            "Person",
            402.67,
            "Påminnelse",
            ["Hundeforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 8, 15),
            "Person",
            2412.67,
            "Inkassovarsel",
            ["Bilforsikring", "Katteforsikring", "Båtforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 7, 15),
            "Person",
            719.17,
            "Faktura",
            ["Båtforsikring", "Hundeforsikring", "Bilforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 6, 15),
            "Skade",
            992.01,
            "Faktura",
            ["Bilforsikring", "Hundeforsikring", "Elsparkesykkel"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 5, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bilforsikring", "Hus", "Bilforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 4, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bilforsikring", "Hundeforsikring", "Bilforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 3, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bilforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 2, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bil", "Hus", "Innbo"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 1, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bilforsikring", "Hundeforsikring", "Katteforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2025, 0, 15),
            "Person",
            772.79,
            "Faktura",
            ["Hundeforsikring", "Barneforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2024, 11, 15),
            "Person",
            772.79,
            "Faktura",
            ["Elsparkesykkel"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2024, 10, 15),
            "Person",
            772.79,
            "Faktura",
            ["Hundeforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2024, 9, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bilforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
        [
            new Date(2024, 8, 15),
            "Person",
            772.79,
            "Faktura",
            ["Bilforsikring", "Hundeforsikring"],
            "9001.17.00771",
            "1631 4283 2245",
            "eFaktura",
        ],
    ],
};
